import { action, makeObservable, observable } from 'mobx';

import ApiService from '../../services/ApiService';
import { EmailValidation } from '../models/EmailValidation';
import { Loadable } from '../models/Loadable';

export default class InvoiceSettingsPanelEmailValidationViewStore {
  @observable
  private emailsValidation: boolean[] = [true];

  constructor(private apiService: ApiService) {
    makeObservable(this);
  }

  @action
  public async loadEmailsValidation(emails: string[]): Promise<any> {
    await Promise.all(
      emails.map(async (email, index) => {
        const emailPromise = this.apiService.validateEmail(email);
        const loadable: Loadable<EmailValidation> = Loadable.toLoadable(emailPromise);
        await emailPromise;
        this.setEmailsValidation(index, loadable.payload.validate === 'VALID');
      })
    );
  }

  @action
  public setEmailsValidation(index: number, isValid: boolean): void {
    this.emailsValidation[index] = isValid;
  }

  public isValidEmail(index: number): boolean {
    return this.emailsValidation[index];
  }
}
